import React from "react";
import "../my component/style.css";

export default function Header() {
  // const stars = Array.from({ length: 20 });
  // ✅ Declare stars array INSIDE the component

  
  return (
    <>
      <section>
        <nav className="header">
          <div className="nav-links">
            <a href="/#home">Home</a>
            <a href="/#about">About</a>
            <a href="/#projects">Projects</a>
            <a href="#contact">Contact</a>
          </div>
        </nav>
      </section>
      {/* <section id="home" className="section1">
        {stars.map((_, index) => {
          const left = Math.random() * 100;
          const delay = Math.random() * 5;
          const duration = 2 + Math.random() * 3;
          return (
            <div
              key={index}
              className="star"
              style={{
                left: `${left}%`,
                animationDelay: `${delay}s`,
                animationDuration: `${duration}s`,
              }}
            />
          );
        })}
        <div className="content">hi</div>
      </section>
      <section className="section2">
        <div>sdfgb</div>
      </section> */}
    </>
  );
}
